import { useDatabaseSelectionPing } from '@databases/ping-registry';
import { defaultStoreUtils } from '@databases/redux';
import { type DefaultRootState } from '@databases/redux';
import {
  selectIsValueSelected,
  selectSelectedValuesCount,
} from '@databases/redux/cellSelections/selectors';

import { getExperimentValue } from '@canvas/client-feature-flags';

/**
 * Supports the legacy redux selector and ping registry for reactive updates.
 */
export function useValueIsOnlySelected(
  contentId: string | undefined,
  entryId: string | undefined,
  fieldId: string
): boolean {
  const reduxValue = defaultStoreUtils.useEqualSelector((state: DefaultRootState) => {
    if (!contentId || !entryId) {
      return false;
    }

    return (
      selectSelectedValuesCount(state, { contentId }) === 1 &&
      selectIsValueSelected(state, { entryId, fieldId })
    );
  });

  const pingValue = useDatabaseSelectionPing((reader) => {
    if (!entryId) {
      return false;
    }

    return reader.getSelectionCount() === 1 && reader.isValueSelected(entryId, fieldId);
  });

  const isSelectionsPerformanceEnabled = getExperimentValue(
    'databasesSelectionsPerformance',
    'isEnabled',
    { fireExperimentExposure: false }
  );

  return isSelectionsPerformanceEnabled ? pingValue : reduxValue;
}
